import styled from 'styled-components';

export const SContainer = styled.div`
  /* Changed from fixed positioning to normal flow to work better with the fixed sidebar */
  position: relative;
  width: 100%;
  background: #ffffff;
  z-index: 950;
`;

export const SItemWrapper = styled.div`
  border-bottom: 1px solid #efefef;
  padding: 20px 0px;
`;

export const SItemName = styled.span`
  font-size: 16px;
`;
